import type { Cookie, CookieOptions } from "./types";


export const tokenMap = new Map<string, [ cookie: Cookie, options: CookieOptions ]>();
